import { gql } from "@apollo/client";

const INVITE_MEMBERS_TO_COLLECTION = gql`
  mutation ($inviteMembersToCollection: InviteMembersToCollectionInputType!) {
    inviteMembersToCollection(inviteMembersToCollection: $inviteMembersToCollection)
  }
`;

export default INVITE_MEMBERS_TO_COLLECTION;
